import LoaderButton from '@/src/components/Commons/LoaderButton/LoaderButton';
import { formatAddress, formatHash } from '@/src/lib/SmartDB/Commons/formatters';
import { showADA_Amount_Rounded, showTokenGov_Amount_Rounded } from '@/src/store/global/tokensStoreModelHelpers';
import { isWebsiteDApp, TOKEN_GOV_TN_STR } from '@/src/utils/constants';
import { TOKEN_ADA_SYMBOL, TOKEN_ADA_TICKER } from '@/src/lib/SmartDB/Commons/Constants/constants';
import { isEmulator } from '@/src/lib/SmartDB/Commons/Constants/constants';
import { COPY2, EYE_HIDE, EYE_SHOW, REPEAT } from '@/src/lib/SmartDB/Commons/Constants/images';
import Image from 'next/image';
import React, { Fragment } from 'react';
import CopyButton from '../CopyButton/CopyButton';
import { useCopyButton } from '../CopyButton/useCopyButton';
import { ModalGetADA } from '../ModalGetADA/ModalGetADA';
import { ModalGetApiToken } from '../ModalGetApiToken/ModalGetApiToken';
import { ModalGetTokenGov } from '../ModalGetTokenGov/ModalGetTokenGov';
import { ModalUTxOsAndBalance } from '../ModalUTxOs/ModalUTxOs';
import OpenInNewTabButton from '../OpenInNewTabButton/OpenInNewTabButton';
import styles from './WalletInfo.module.scss';
import useWalletInfo from './useWalletInfo';
import { toJson } from '@/src/lib/MayzSmartDB';

interface IWalletInfoProps {
    isForModal: boolean;
}

const WalletInfo: React.FC<IWalletInfoProps> = (props) => {
    //-------------
    const { isForModal } = props;
    //-------------
    const { isRefreshing, appStore, walletStore, tokensStore, session, status, handleToggleIsHide, wallet, handleClickToggleAdminMode, handleClickToggleDontPromtForSigning } =
        useWalletInfo();
    //--------------------------------------
    const { handleBtnCopy } = useCopyButton();
    //--------------------------------------
    if (isForModal === true) {
        return (
            <Fragment>
                {walletStore.isConnected === true && wallet !== undefined && (
                    <>
                        <div className={styles.yourWalletModal}>
                            <div className={styles.nextRow}>
                                <div className={styles.buttons}>
                                    <div className={styles.refresh}>
                                        {status === 'loading' || walletStore.isConnecting || walletStore.isLoadingAnyData ? (
                                            <LoaderButton />
                                        ) : (
                                            <svg
                                                width="14"
                                                height="14"
                                                id="icon"
                                                className={styles.icon}
                                                onClick={() => {
                                                    walletStore.loadWalletData({ swLoadParticipation: true, swLoadSwapOffers: true });
                                                }}
                                            >
                                                <use href={REPEAT}></use>
                                            </svg>
                                        )}
                                        <div className={styles.textWrapper3}>Refresh</div>
                                    </div>
                                    <div className={styles.hideBalance}>
                                        <svg
                                            width="19"
                                            height="19"
                                            className={styles.icon}
                                            onClick={() => {
                                                handleToggleIsHide();
                                            }}
                                        >
                                            <use href={walletStore.swHideBalance === true ? EYE_HIDE : EYE_SHOW}></use>
                                        </svg>
                                        <div className={styles.textWrapper3}>Hide balance</div>
                                    </div>
                                    {(walletStore.info?.isWalletFromSeed === true || walletStore.info?.isWalletFromKey === true) && (
                                        <div className={styles.toggleController}>
                                            <p className={`${styles.text} ${!walletStore.swDoNotPromtForSigning ? styles.active : ''}`}></p>
                                            <div className={styles.toggle} onClick={handleClickToggleDontPromtForSigning}>
                                                <span className={`${styles.point} ${!walletStore.swDoNotPromtForSigning ? styles.active : ''}`}></span>
                                            </div>
                                            <p className={`${styles.text} ${walletStore.swDoNotPromtForSigning ? styles.active : ''}`}>Auto</p>
                                        </div>
                                    )}
                                    <div className={styles.toggleController}>
                                        <p className={`${styles.text} ${!walletStore.info?.isWalletValidatedWithSignedToken ? styles.active : ''}`}></p>
                                        <div className={styles.toggle} onClick={handleClickToggleAdminMode}>
                                            <span className={`${styles.point} ${!walletStore.info?.isWalletValidatedWithSignedToken ? styles.active : ''}`}></span>
                                        </div>
                                        <p className={`${styles.text} ${walletStore.info?.isWalletValidatedWithSignedToken ? styles.active : ''}`}>Admin</p>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.nextRow}>
                                <div className={styles.address}>
                                    <div className={styles.walletLogo}>
                                        <Image src={wallet!.icon} width="100%" height="100%" layout="responsive" objectFit="contain" alt="Wallet logo" />
                                    </div>
                                    <div className={styles.div}>
                                        <div className={styles.textWrapper}>Address</div>
                                        <div className={styles.address2}>
                                            <div className={styles.textWrapper2}>{formatAddress(walletStore.info!.address, false)}</div>
                                            <div className={styles.iconCopy}>
                                                <CopyButton content={walletStore.info!.address} />
                                            </div>
                                            <div className={styles.iconOpen}>
                                                <OpenInNewTabButton
                                                    url={
                                                        appStore.siteSettings !== undefined
                                                            ? `${appStore.siteSettings.getblockfrost_url_explorer_address(walletStore.info!.address)}`
                                                            : ``
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <div className={styles.divModalPkh}>
                                    <div className={styles.textWrapper}>Pkh</div>
                                    <div className={styles.textWithCopy}>
                                        <div className={styles.textWrapper4}>{formatHash(walletStore.info!.pkh)}</div>
                                        <CopyButton content={walletStore.info!.pkh} />
                                    </div>
                                </div> */}
                            </div>
                            <div className={styles.nextRow}>
                                <div className={styles.rowCointainer}>
                                    <div className={styles.walletDescription}>
                                        <div className={styles.row}>
                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>{TOKEN_ADA_TICKER} balance</div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? `*** ${TOKEN_ADA_SYMBOL}`
                                                        : showADA_Amount_Rounded(
                                                              tokensStore,
                                                              walletStore.isLoadingAnyData === true ? undefined : BigInt(walletStore.getTotalOfUnit('lovelace'))
                                                          )}
                                                </div>
                                            </div>

                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>{TOKEN_GOV_TN_STR} balance</div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? `*** ${TOKEN_GOV_TN_STR}`
                                                        : showTokenGov_Amount_Rounded(tokensStore, walletStore.isLoadingAnyData === true ? undefined : walletStore.tokenGov)}
                                                </div>
                                            </div>

                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>My Valuation</div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? `*** ${TOKEN_ADA_SYMBOL}`
                                                        : showADA_Amount_Rounded(tokensStore, walletStore.isLoadingAnyData === true ? undefined : walletStore.getTotalValuation)}
                                                </div>
                                            </div>
                                            {isWebsiteDApp && (
                                                <div className={styles.divData}>
                                                    <div className={styles.textWrapper}>My Stake</div>
                                                    <div className={styles.textWrapper4}>
                                                        {walletStore.swHideBalance === true
                                                            ? `*** ${TOKEN_GOV_TN_STR}`
                                                            : showTokenGov_Amount_Rounded(
                                                                  tokensStore,
                                                                  walletStore.isLoadingAnyData === true ? undefined : walletStore.getTotalStaked
                                                              )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <div className={styles.row}>
                                            {appStore.siteSettings?.debug === true ? (
                                                <>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>Admin Mode Active:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.info?.isWalletValidatedWithSignedToken ? 'Yes' : 'No'}</p>
                                                    </div>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>Core Team:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.isCoreTeam(true, session, status) ? 'Yes' : 'No'}</p>
                                                    </div>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>Protocol Admin:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.isProtocolAdmin(true, session, status) ? 'Yes' : 'No'}</p>
                                                    </div>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>Fund Admin:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.isFundAdmin(true, session, status) ? 'Yes' : 'No'}</p>
                                                    </div>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>{TOKEN_GOV_TN_STR} Holder:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.isTokenGovHolder() ? 'Yes' : 'No'}</p>
                                                    </div>
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.nextRow}>
                                {walletStore.isCoreTeam() && appStore.siteSettings?.debug === true ? (
                                    <ModalUTxOsAndBalance address={walletStore.info!.address} uTxOs={walletStore.uTxOsAtWallet} />
                                ) : null}
                                {isEmulator ? <ModalGetADA /> : null}
                                {isEmulator ? <ModalGetTokenGov /> : null}
                                {walletStore.isCoreTeam() && appStore.siteSettings?.debug === true ? <ModalGetApiToken /> : null}
                            </div>
                        </div>
                    </>
                )}
            </Fragment>
        );
    } else {
        return (
            <Fragment>
                {walletStore.isConnected === true && wallet !== undefined && (
                    <>
                        <div className={styles.yourWallet}>
                            <div className={styles.firtsRow}>
                                <div className={styles.titleAndLoading}>
                                    <div className={styles.titleWallet}>your wallet [{walletStore.info!.walletName}]</div>
                                </div>
                                <div className={styles.buttons}>
                                    <div className={styles.refresh}>
                                        {status === 'loading' || walletStore.isConnecting || walletStore.isLoadingAnyData ? (
                                            <LoaderButton />
                                        ) : (
                                            <svg
                                                width="14"
                                                height="14"
                                                id="icon"
                                                className={styles.icon}
                                                onClick={() => {
                                                    walletStore.loadWalletData({ swLoadParticipation: true, swLoadSwapOffers: true });
                                                }}
                                            >
                                                <use href={REPEAT}></use>
                                            </svg>
                                        )}
                                        <div className={styles.textWrapper3}>Refresh</div>
                                    </div>
                                    <div className={styles.hideBalance}>
                                        <svg
                                            width="19"
                                            height="19"
                                            className={styles.icon}
                                            onClick={() => {
                                                handleToggleIsHide();
                                            }}
                                        >
                                            <use href={walletStore.swHideBalance === true ? EYE_HIDE : EYE_SHOW}></use>
                                        </svg>
                                        <div className={styles.textWrapper3}>Hide balance</div>
                                    </div>
                                    {(walletStore.info?.isWalletFromSeed === true || walletStore.info?.isWalletFromKey === true) && (
                                        <div className={styles.toggleController}>
                                            <p className={`${styles.text} ${!walletStore.swDoNotPromtForSigning ? styles.active : ''}`}></p>
                                            <div className={styles.toggle} onClick={handleClickToggleDontPromtForSigning}>
                                                <span className={`${styles.point} ${!walletStore.swDoNotPromtForSigning ? styles.active : ''}`}></span>
                                            </div>
                                            <p className={`${styles.text} ${walletStore.swDoNotPromtForSigning ? styles.active : ''}`}>Auto</p>
                                        </div>
                                    )}
                                    <div className={styles.toggleController}>
                                        <p className={`${styles.text} ${!walletStore.info?.isWalletValidatedWithSignedToken ? styles.active : ''}`}></p>
                                        <div className={styles.toggle} onClick={handleClickToggleAdminMode}>
                                            <span className={`${styles.point} ${!walletStore.info?.isWalletValidatedWithSignedToken ? styles.active : ''}`}></span>
                                        </div>
                                        <p className={`${styles.text} ${walletStore.info?.isWalletValidatedWithSignedToken ? styles.active : ''}`}>Admin</p>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.nextRow}>
                                <div className={styles.address}>
                                    <div className={styles.walletLogo}>
                                        <Image src={wallet!.icon} width="100%" height="100%" layout="responsive" objectFit="contain" alt="Wallet logo" />
                                    </div>
                                    <div className={styles.div}>
                                        <div className={styles.textWrapper}>Address</div>
                                        <div className={styles.address2}>
                                            <div className={styles.textWrapper2}>{formatAddress(walletStore.info!.address)}</div>
                                            <div className={styles.iconCopy}>
                                                <CopyButton content={walletStore.info!.address} />
                                            </div>
                                            <div className={styles.iconOpen}>
                                                <OpenInNewTabButton
                                                    url={
                                                        appStore.siteSettings !== undefined
                                                            ? `${appStore.siteSettings.getblockfrost_url_explorer_address(walletStore.info!.address)}`
                                                            : ``
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={styles.rowCointainer}>
                                    <div className={styles.walletDescription}>
                                        <div className={styles.row}>
                                            {/* <div className={styles.divData}>
                                            <div className={styles.textWrapper}>Wallet</div>
                                            <div className={styles.textWrapper4}>{walletStore.info!.walletName}</div>
                                        </div> */}
                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>Pkh</div>
                                                <div className={styles.textWithCopy}>
                                                    <div className={styles.textWrapper4}>{formatHash(walletStore.info!.pkh)}</div>
                                                    <CopyButton content={walletStore.info!.pkh} />
                                                </div>
                                            </div>

                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>{TOKEN_ADA_TICKER} Balance </div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? `*** ${TOKEN_ADA_SYMBOL}`
                                                        : showADA_Amount_Rounded(
                                                              tokensStore,
                                                              walletStore.isLoadingAnyData === true ? undefined : BigInt(walletStore.getTotalOfUnit('lovelace'))
                                                          )}
                                                </div>
                                            </div>
                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>{TOKEN_ADA_TICKER} Available </div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? `*** ${TOKEN_ADA_SYMBOL}`
                                                        : showADA_Amount_Rounded(
                                                              tokensStore,
                                                              walletStore.isLoadingAnyData === true ? undefined : BigInt(walletStore.getTotalOfUnit('lovelace', true))
                                                          )}
                                                </div>
                                            </div>
                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>{TOKEN_GOV_TN_STR} Balance</div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? `*** ${TOKEN_GOV_TN_STR}`
                                                        : showTokenGov_Amount_Rounded(tokensStore, walletStore.isLoadingAnyData === true ? undefined : walletStore.tokenGov)}
                                                </div>
                                            </div>
                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>Fund Tokens</div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? `***`
                                                        : walletStore.isLoadingAnyData || walletStore.isParticipationLoaded === false
                                                        ? '...'
                                                        : walletStore.tokensFT?.length ?? 0}
                                                </div>
                                            </div>
                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>Other Tokens</div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? '***'
                                                        : walletStore.isLoadingAnyData || walletStore.isParticipationLoaded === false
                                                        ? '...'
                                                        : walletStore.getTotalNumberOfTokens - (walletStore.tokensFT?.length ?? 0)}
                                                </div>
                                            </div>
                                            <div className={styles.divData}>
                                                <div className={styles.textWrapper}>My Valuation</div>
                                                <div className={styles.textWrapper4}>
                                                    {walletStore.swHideBalance === true
                                                        ? `*** ${TOKEN_ADA_SYMBOL}`
                                                        : showADA_Amount_Rounded(tokensStore, walletStore.isLoadingAnyData === true ? undefined : walletStore.getTotalValuation)}
                                                </div>
                                            </div>
                                            {isWebsiteDApp && (
                                                <div className={styles.divData}>
                                                    <div className={styles.textWrapper}>My Stake</div>
                                                    <div className={styles.textWrapper4}>
                                                        {walletStore.swHideBalance === true
                                                            ? `*** ${TOKEN_GOV_TN_STR}`
                                                            : showTokenGov_Amount_Rounded(
                                                                  tokensStore,
                                                                  walletStore.isLoadingAnyData === true ? undefined : walletStore.getTotalStaked
                                                              )}
                                                    </div>
                                                </div>
                                            )}
                                            {/* <div className={styles.divData}>
                                        <div className={styles.textWrapper}>24h PNL</div>
                                        <div className={styles.textWrapper5}>178 :: 1.8% ₳</div>
                                    </div> */}
                                        </div>
                                        <div className={styles.row}>
                                            {appStore.siteSettings?.debug === true ? (
                                                <>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>Admin Mode Active:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.info?.isWalletValidatedWithSignedToken ? 'Yes' : 'No'}</p>
                                                    </div>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>Core Team:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.isCoreTeam(true, session, status) ? 'Yes' : 'No'}</p>
                                                    </div>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>Protocol Admin:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.isProtocolAdmin(true, session, status) ? 'Yes' : 'No'}</p>
                                                    </div>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>Fund Admin:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.isFundAdmin(true, session, status) ? 'Yes' : 'No'}</p>
                                                    </div>
                                                    <div className={styles.divData}>
                                                        <p className={styles.textWrapper}>{TOKEN_GOV_TN_STR} Holder:</p>
                                                        <p className={styles.textWrapper4}>{walletStore.isTokenGovHolder() ? 'Yes' : 'No'}</p>
                                                    </div>
                                                </>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.nextRow}>
                                {walletStore.isCoreTeam() && appStore.siteSettings?.debug === true ? (
                                    <ModalUTxOsAndBalance address={walletStore.info!.address} uTxOs={walletStore.uTxOsAtWallet} />
                                ) : null}
                                {isEmulator ? <ModalGetADA /> : null}
                                {isEmulator ? <ModalGetTokenGov /> : null}
                                {walletStore.isCoreTeam() && appStore.siteSettings?.debug === true ? <ModalGetApiToken /> : null}
                            </div>
                        </div>
                        <section className={styles.gapSection}></section>
                    </>
                )}
            </Fragment>
        );
    }
};

export default WalletInfo;
